
import { defineComponent } from "vue";
import CustomLabel from "./CustomLabel.vue";

import { v4 as uuidv4 } from "uuid";

export default defineComponent({
  name: "CustomSwitch",
  props: {
    label: String,
    initialValue: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    CustomLabel,
  },
  emits: ["switch-input"],
  data() {
    return {
      value: this.initialValue,
      id: uuidv4(),
    };
  },
  watch: {
    value() {
      this.$emit("switch-input", this.value);
    },
  },
});
